<template>
  <div class="modal-backdrop">
    <div class="modal">
      <header class="modal-header">
        <slot name="header">
          Add model
        </slot>
        <button
          type="button"
          class="btn-close"
          @click="close"
        >
          x
        </button>
      </header>

      <section class="modal-body">
          <div id="addModel">
            <b-form @submit="addModel">
              <b-form-group class="input-group-admin" label="English Name">
                <b-form-input
                  type="text"
                  v-model="name"
                  placeholder="Enter English model name">
                </b-form-input>
              </b-form-group>
              <b-form-group class="input-group-admin" label="Slovenian Name">
                <b-form-input
                  type="text"
                  v-model="name_slo"
                  placeholder="Enter Slovenian model name">
                </b-form-input>
              </b-form-group>

              <b-form-group class="input-group-admin" label="Short English Description">
                <b-form-input
                  type="text"
                  v-model="short_description"
                  placeholder="Enter short English description (up to 20 words long)"
                  
                ></b-form-input>
              </b-form-group>
              <b-form-group class="input-group-admin" label="Short Slovenian Description">
                <b-form-input
                  type="text"
                  v-model="short_description_slo"
                  placeholder="Enter short Slovenian description (up to 20 words long)"
                ></b-form-input>
              </b-form-group>
              
              <b-form-group class="input-group-admin" label="English Description">
                <b-form-textarea
                  type="textarea"
                  v-model="description"
                  rows="4"
                  max-rows="8"
                  placeholder="Enter long English description"  
                ></b-form-textarea>
              </b-form-group>

              <b-form-group class="input-group-admin" label="Slovenian Description">
                <b-form-textarea
                  type="textarea"
                  v-model="description_slo"
                  rows="4"
                  max-rows="8"
                  placeholder="Enter long Slovenian description"  
                ></b-form-textarea>
              </b-form-group>

              <b-form-group class="input-group-admin" label="Input JSON">
                <b-form-textarea
                  type="textarea"
                  v-model="input_json"
                  rows="4"
                  max-rows="6"
                  placeholder="Enter API input JSON, e.g. {text:string}">
                </b-form-textarea>
              </b-form-group>

              <b-form-group class="input-group-admin" label="API URL">
                <b-form-input
                  type="text"
                  v-model="api_url"
                  placeholder="Enter full URL to the REST service">
                </b-form-input>
              </b-form-group>

              <b-form-group class="input-group-admin" label="API documentation URL">
                <b-form-input
                  type="text"
                  v-model="api_doc_url"
                  placeholder="Enter full URL to the REST service documentation">
                </b-form-input>
              </b-form-group>

              <b-form-group class="input-group-admin" label="GIT URL">
                <b-form-input
                  type="text"
                  v-model="git_url"
                  placeholder="Enter full URL to the GIT repository of the model">
                </b-form-input>
              </b-form-group>

              <b-form-group class="input-group-admin" label="Paper URL">
                <b-form-input
                  type="text"
                  v-model="paper_url"
                  placeholder="Enter full URL to the paper describing the model">
                </b-form-input>
              </b-form-group>

              <b-form-group class="input-group-admin" label="Model type">
                <div>
                  <b-form-select 
                    id="input-8"
                    v-model="selected" 
                    :options="options">
                  </b-form-select>
                </div>
              </b-form-group>
            </b-form>
        </div>
       </section>

      <footer class="modal-footer">
        <b-button pill v-on:click="addModel" id="button-1" type="button" variant="dark">Add Model</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModelAdd',
    data(){
      return {
        name : "",
        name_slo : "",
        description : "",
        description_slo : "",
        short_description : "",
        short_description_slo : "",
        input_json : "",
        api_url : "",
        api_doc_url : "",
        git_url : "",
        paper_url : "",
        selected: 'Document classification',
        options: [
          { value: 'Document classification', text: 'Document classification' },
          { value: 'Sequence labelling', text: 'Sequence labelling' },
          { value: 'Other', text: 'Other' },
          { value: 'LLM', text: 'LLM' }
        ]
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      addModel() {
        let model_data = {
          name: this.name,
          name_slo: this.name_slo,
          description: this.description,
          description_slo: this.description_slo,
          short_description: this.short_description,
          short_description_slo: this.short_description_slo,
          input_json: this.input_json,
          api_url: this.api_url,
          api_doc_url: this.api_doc_url,
          git_url: this.git_url,
          paper_url: this.paper_url,
          type: this.selected,
        }
        this.$http({url: this.$hostname + '/api/model/add', data: model_data, method: 'POST' })
        .then(resp => {
          console.log(resp);
          this.$emit('close'); 
        })
        .catch(err => {
          console.error(err);
        })
      }
    },
  };
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #7A7877;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: auto;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #7A7877;
    background: transparent;
  }

  #button-1 {
    margin: auto;
  }
</style>
